import {
  DEFAULT_GRID_COLUMNS,
  DEFAULT_GRID_ROWS,
} from '../components/PageConfigProvider/constants';
import {
  type Page,
  PageType,
  RevelioPageId,
} from '../components/PageConfigProvider/types';
import { FilterId } from '../filters/types/filters';

export const talentDiscovery: Page = {
  type: PageType.REVELIO_PUBLIC,
  id: RevelioPageId.TALENT_DISCOVERY,
  revelioPageId: RevelioPageId.TALENT_DISCOVERY,
  name: 'Talent Discovery',
  owner: { id: 'revelio-labs', username: 'revelio-labs' },
  tabs: [
    {
      id: 'talent-discovery-default',
      label: 'Talent Discovery',
      isActive: true,
      tabContent: {
        id: 'talent-discovery-default',
        grid: { rows: DEFAULT_GRID_ROWS, columns: DEFAULT_GRID_COLUMNS },
        secondaryFilters: [
          { id: FilterId.MULTI_COMPANY },
          { id: FilterId.MULTI_GEOGRAPHY },
          { id: FilterId.MULTI_ROLE },
          { id: FilterId.MULTI_CUSTOM_SKILL },
          { id: FilterId.MULTI_KEYWORDS },
          { id: FilterId.NAME },
          { id: FilterId.MULTI_TITLE },
          { id: FilterId.MULTI_SENIORITY },
          { id: FilterId.MULTI_GENDER },
          { id: FilterId.MULTI_ETHNICITY },
          { id: FilterId.MULTI_EDUCATION },
          { id: FilterId.MULTI_GRADUATION_YEAR },
          { id: FilterId.MULTI_PAY },
          { id: FilterId.MULTI_YEARS_OF_EXPERIENCE },
          { id: FilterId.MULTI_EMPLOYMENT_RELATIONSHIP },
          { id: FilterId.MULTI_WORK_SCHEDULE },
          { id: FilterId.MULTI_FLIGHT_RISK },
          { id: FilterId.MULTI_PRESTIGE },
          { id: FilterId.MULTI_REMOTE_SUITABILITY },
          { id: FilterId.MULTI_SCHOOL },
        ],
        items: [
          {
            id: 'talent-discovery-table',
            title: 'Results',
            position: {
              x: 0,
              y: 0,
              width: DEFAULT_GRID_COLUMNS / 2,
              height: DEFAULT_GRID_ROWS,
            },
            plot: {
              chartType: 'table',
              defaultMetricOptions: ['td_users'],
              showZebraStripe: true,
              tableRowPopout: {
                chartType: 'full-profile-info',
              },
            },
          },
          {
            id: 'talent-discovery-map',
            title: '',
            position: {
              x: DEFAULT_GRID_COLUMNS / 2,
              y: 0,
              width: DEFAULT_GRID_COLUMNS / 2,
              height: DEFAULT_GRID_ROWS,
            },
            plot: {
              chartType: 'map',
              defaultMetricOptions: ['td_users'],
              mapOptions: {
                normalization: 'area_density',
                transformation: 'sqrt',
              },
              color: '#5BD992',
            },
          },
        ],
      },
    },
  ],
};
